import PropTypes from 'prop-types';
import styled from 'styled-components';
import * as styleHelpers from '../../helpers/styleHelpers';

const renderPadding = styleHelpers.sizeShortHandGenerator('padding');

export const Wrapper = styled.div`
  ${props => (props.fullScreen ? `height: 100vh; position: relative;` : ``)};
  ${props => renderPadding(props.theme, props.size)};
  ${props =>
    Object.keys(props.sizes).map(
      key =>
        `${styleHelpers.breakPoint(props.theme.breakPoints[key], size =>
          styleHelpers.renderUnitSize(props.theme, size),
        )} {
        ${renderPadding(props.theme, props.sizes[key])}}
      }`,
    )};
`;
// const sizeOptions = [0.5, 1, 2, 3];
// Wrapper.propTypes = {
//   size: PropTypes.oneOf(sizeOptions),
//   sizes: PropTypes.objectOf(PropTypes.oneOf(sizeOptions)),
// };
// Wrapper.defaultProps = {
//   size: 1,
//   sizes: {},
// };

export const Relative = styled.div`
  position: relative;
`;

export const PageWrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;



// WEBPACK FOOTER //
// ./src/components/primitives/layout.js